export default "__VITE_ASSET__tfQLYwjC__"